import { sessionIdName } from 'const/session'
import { getAppSessionItem } from 'helpers/appSessionItem'
import { setSessionID } from 'helpers/authUtils'
import getTransId from './getTransId'
import { getCookie } from './cookie'

/**
 * Gets the correlationId value from session storage. Fallback to a random
 * string if no correlationId available.
 * @returns str - the correlation id value, looks like "d9c4eb73-58e8-4b66-a8f9-0dbdc76e3586"
 */
const getCorrelationId = (): string => {
  let correlationId = getAppSessionItem(sessionIdName)
  const cookieCorrelationId = getCookie(sessionIdName)
  if (!correlationId && !cookieCorrelationId) {
    // so fn returns this generated value
    correlationId = getTransId()
    setSessionID(getTransId())
  }
  return correlationId || cookieCorrelationId
}

export default getCorrelationId
